export default __webpack_public_path__ + "static/media/PokemonSolid.5d60be1f.ttf";